import React, { useRef, useState, useEffect } from 'react';
import LightboxGroup from '../../../../components/LightboxGroup/LightboxGroup';
import styles from './Comment.module.scss';

const Images = ({ images }) => {
  const showPreviewRef = useRef();

  const [showPreview, setShowPreview] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const loader = (fileName) => {
    const image = images.find((image) => image.fileName === fileName);
    return image.src;
  };

  const handleImageClick = (currentImageIndex) => {
    setShowPreview(true);

    setCurrentImageIndex(currentImageIndex);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  useEffect(() => {
    if (showPreviewRef.current) {
      showPreviewRef.current.focus();
    }
  }, [showPreviewRef]);

  return (
    <div className={styles.attachedImages}>
      {images.map((image, index) => (
        <img
          key={image.id}
          src={image.src}
          alt="img"
          className={styles.attachedImagePreview}
          onClick={() => handleImageClick(index)}
        />
      ))}
      {showPreview && (
        <div autoFocus ref={showPreviewRef} tabIndex={0}>
          <LightboxGroup
            onClose={handleClosePreview}
            visible={showPreview}
            attachments={images}
            attachment={images[currentImageIndex]}
            loader={loader}
          />
        </div>
      )}
    </div>
  );
};

export default Images;
